import type { ReactNode } from 'react';

export const THEMES = ['light', 'dark', 'contrast', 'system'] as const;

export type Theme = (typeof THEMES)[number];

export type ResolvedTheme = Exclude<Theme, 'system'>;

export const THEME_STORAGE_KEY = 'eklase:theme';

export interface ThemeOption {
  value: Theme;
  label: string;
  icon: ReactNode;
}
